import React from 'react'


type ButtonType={
    label:string,
    onClick?:any,
}

function Button({label,onClick}:ButtonType) {
  return (
    <button className='rounded bg-primary-color text-white px-6 py-1' type="submit" onClick={(e:React.MouseEvent<HTMLButtonElement, MouseEvent>)=>{onClick()}}>{label}</button>
  )
}

export default Button